import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { Typography } from '@mui/material';
export const AbilityContext = createContext(undefined);
export const Can = createContextualCan(AbilityContext.Consumer);
export const CustomCan = ({ I, a, children }) => (_jsx(Can, { I: I, a: a, passThrough: true, children: (allowed) => allowed ? (children) : (_jsx(Typography, { variant: "body1", sx: { mt: 2 }, children: "Vous n'avez pas la permission d'acc\u00E9der \u00E0 cette section" })) }));
